<template>
  <div class="table-responsive">
    <table class="table" style="width: 100%;">
      <thead>
        <tr>
          <th class="w-5">{{ $t("finding.no") }}</th>
          <th>{{ $t("finding.status") }}</th>
          <th>{{ $t("finding.name") }}</th>
          <th>{{ $t("audit-finding.detection-date") }}</th>
          <!-- <th>{{ $t("audit-finding.source.text") }}</th> -->
          <th>{{ $t("audit-finding.category.text") }}</th>
          <th>{{ $t("audit-finding.level") }}</th>
          <th>{{ $t("audit-finding.class.text") }}</th>
          <th>{{ $t("finding.target.resolution-duration") }}</th>
          <th>{{ $t("finding.criticality.text") }}</th>
          <th>{{ $t("finding.manager") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="pagination && pagination.docs.length">
        <tr v-for="item in pagination.docs" :key="item._id" class="hider">
          <td>
            <div>{{ item.no }}</div>
          </td>
          <td>
            <b-badge :variant="getVariant(item.status)"
              ><span v-if="item.status">{{ $t(`audit-finding.status.${item.status.toLowerCase()}`) }}</span></b-badge
            >
          </td>
          <td>
            <div>{{ item.name | translate }}</div>
          </td>
          <td>
            <div>{{ item.detectionDate | date }}</div>
          </td>
          <!-- <td>
            <div>
              <span v-if="item.source">{{ item.source.name | translate }}</span>
            </div>
          </td> -->
          <td>
            <div>
              <span v-if="item.category">{{ item.category.name | translate }}</span>
            </div>
          </td>
          <td>
            <div>
              <div v-if="item.owner && item.owner.organization">{{ item.owner.organization.name | translate }}</div>
              <div v-else-if="item.owner && item.owner.department">{{ item.owner.department.name | translate }}</div>
              <div v-else-if="item.owner && item.owner.process">{{ item.owner.process.name | translate }}</div>
            </div>
          </td>
          <td>
            <div>
              <span v-if="item.class">{{ $t(`audit-finding.class-options.${item.class.toLowerCase()}`) }}</span>
            </div>
          </td>
          <td>
            <div>{{ item.targetResolutionDate | date }}</div>
          </td>
          <td>
            <div v-if="item.criticality">{{ $t(`finding.criticality.${item.criticality.toLowerCase()}`) }}</div>
          </td>
          <td>
            <div>{{ item.manager | translate }}</div>
          </td>
          <td>
            <div class="d-flex" style="gap: 10px;">
              <i class="iconoir-edit hand" @click="$router.push(`/finding/detail/${item._id}`)"></i>
              <!-- <i class="iconoir-trash hand" @click="$emit('delete', item._id)"></i> -->
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getVariant(status) {
      const map = {
        AWAITING_APPROVAL: "warning",
        APPROVED_EVALUATING: "success",
        REJECTED_EVALUATING: "danger",
        EDIT_REQUESTED_EVALUATING: "primary",
        ACTION_PLAN_MONITORING: "info",
        EXTENSION_APPROVAL: "warning",
        COMPLETED: "success",
        PASSIVE: "secondary",
        CANCELED: "danger",
      };
      return map[status] || "secondary";
    },
  },
};
</script>
